module.exports = {"320312001":"三河尖街道","320312002":"张双楼街道","320312003":"垞城街道","320312004":"张集街道","320312006":"利国街道","320312007":"电厂街道","320312008":"拾屯街道","320312009":"铜山街道","320312010":"沿湖街道","320312051":"新区街道","320312052":"三堡街道","320312102":"何桥镇","320312103":"黄集镇","320312104":"马坡镇","320312105":"郑集镇","320312106":"柳新镇","320312107":"刘集镇","320312108":"大彭镇","320312109":"汉王镇","320312111":"棠张镇","320312112":"张集镇","320312113":"房村镇","320312114":"伊庄镇","320312115":"单集镇","320312116":"利国镇","320312118":"大许镇","320312119":"茅村镇","320312120":"柳泉镇","320312402":"徐州高新技术产业开发区","320312403":"江苏铜山经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320312.json
// module id = 852
// module chunks = 0